import { Extent } from "ol/extent"
import { Layer } from "../state"

export function createIconElement(iconName: string) {
  const result = document.createElement("i")
  result.classList.add("fas", `fa-${iconName}`)
  return result
}

export function iconForLayerType(type: Layer['type']) {
  switch (type) {
    case "OsmLayer":
    case "MapTileLayer":
    case "WcsRgbLayer":
      return "fa-image"
    case "OverlayLayer":
      return "fa-draw-polygon"
    case "ModelOutputLayer":
    //case "MLLayer":
      return "fa-project-diagram"
    case "ShapeLayer":
    case "BoundaryLayer":
      return "fa-draw-polygon"
    case "AtiLayer":
      return "fa-tree"
    case "KewLayer":
    case "KewPointLayer":
      return "fa-leaf"
    case "KewShapeLayer":
      return "fa-tree"
    case "PaintbrushGeoJSONLayer":
      return "fa-paint-brush"
    default:
      return "fa-layer-group"
  }
}

export function shortLabelForLayerType(type: Layer['type']): string {
  switch (type) {
    case "OsmLayer":
      return "OSM"
    case "MapTileLayer":
      return "Tiles"
    case "WcsRgbLayer":
      return "RGB"
    case "OverlayLayer":
      return "Overlay"
    case "ModelOutputLayer":
      return "Model"
    case "ShapeLayer":
      return "Shape"
    case "BoundaryLayer":
      return "Boundary"
    case "AtiLayer":
      return "ATI"
    case "KewLayer":
      return "Kew"
    case "KewPointLayer":
      return "Kew points"
    case "KewShapeLayer":
      return "Kew shape"
    case "NevoLayer":
      return "NEVO"
    case "ORValLayer":
      return "ORVal"
    case "IMDLayer":
      return "IMD"
    case "CehLandCoverLayer":
      return "Land cover"
    case "CropMapLayer":
      return "Crop map"
    case "DatasetLayer":
      return "Dataset"
    case "GeoserverLayer":
      return "GeoServer"
    case "WFSLayer":
      return "WFS"
    case "PaintbrushGeoJSONLayer":
      return "Paintbrush"
    default:
      return "Layer"
  }
}

// TODO: Not really extents
export function mergeExtents(a, b) {
  return [
    Math.min(a[0], b[0]),
    Math.min(a[1], b[1]),
    Math.max(a[2], b[2]),
    Math.max(a[3], b[3]),
  ]
}

// TODO: Not really extents
export function intersectExtents(a, b) {
  return [
    Math.max(a[0], b[0]),
    Math.max(a[1], b[1]),
    Math.min(a[2], b[2]),
    Math.min(a[3], b[3]),
  ]
}
